import { CustomPagination, CustomToolTip } from 'components';
import BootstrapTable from 'components/BootstrapTable';
import { utils } from 'helper';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { StorageServices } from 'utils';
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { getServiceList, getServiceVoucherList } from '_services/workShopServices/workShopServices';
import toast from 'react-hot-toast';
import { MakePaymentOfServiceModal, PaymentConfirmModal, PaymentProcessingOffcanvas, PaymentStatusCard } from 'modals';
import moment from 'moment';
import { constant } from 'constants';

// ─── Props from parent (PaymentTransaction):
//   search, dateRange, vehicleId, vendorId, status, offset, onPageChange
const WorkshopServicingVoucher = ({
    search = "",
    dateRange = null,
    vehicleId = {},
    vendorId = {},
    status = "",
    offset = 1,
    onPageChange,
    activeTab
}) => {
    const ITEMS_PER_PAGE = 12;
    const navigate = useNavigate();

    const [totalRecord, setTotalRecord] = useState(0);
    const [serviceList, setServiceList] = useState([]);
    const [isOpenMakePayment, setIsOpenMakePayment] = useState(false);
    const [isOpenPayNow, setIsOpenPayNow] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isMakeStatusOpen, setIsMakeStatusOpen] = useState(false);
    const [paymentData, setPaymentData] = useState({ voucher_id: "", data: {} });
    const [eaesbuzzId, setEaesbuzzId] = useState({ eb_account_id: "", total_amount: 0 });

    // ✅ Fix: Object ke bajay sirf primitive values use karo
    useEffect(() => {
        getServiceHandle();
    }, [search, dateRange, vehicleId?._id, vendorId?.value, status, offset]);

    const getServiceHandle = async () => {
        const payload = {
            company_id: StorageServices.getCompanyId(),
            limit: ITEMS_PER_PAGE,
            offset,
            search,
            vehicle_id: vehicleId?._id || "",
            vendor_id: vendorId?.value || "",
            status,
            ...(dateRange && {
                start_date: moment(dateRange.start).format("YYYY-MM-DD"),
                end_date: moment(dateRange.end).format("YYYY-MM-DD"),
            }),
        };
        try {
            const res = await getServiceVoucherList(payload);
            if (res?.responseCode === 200) {
                setServiceList(res?.data?.list);
                setTotalRecord(res?.data?.total_record);
            }
        } catch (error) {
            console.error("Error fetching service list:", error);
        }
    };

    const getStatusStyle = (status) => {
        const map = {
            Completed: { label: "Completed", color: "#22C55E" },
            Cancelled: { label: "Cancelled", color: "#EF4444" },
            Pending: { label: "Pending", color: "#F97316" },
        };
        return map[status] || { label: status || "-", color: "#6B7280" };
    };

    const columns = [

        { header: "# Number", accessor: "number" },
        { header: "Servicing Date", accessor: "service_date" },
        { header: "Firm name", accessor: "firm_name" },
        { header: "Vendor", accessor: "vendor_detail" },
        { header: "Vehicle Number", accessor: "vehicle" },
        { header: "Total Amount", accessor: "sub_total" },
        { header: "Due Balance", accessor: "due_amount" },
        { header: "Under Approval Amount", accessor: "approval_amount" },
        { header: "Bill Status", accessor: "service_status" },
        { header: "Action", accessor: "actionButton" },
    ];

    const rowListData = (data = []) =>
        data.map(item => {
            const { label, color } = getStatusStyle(item?.payment_status);
            return {
                _id: item._id,
                original: item,
                number: <span>{item.sequence_no || "-"}</span>,
                approval_amount: Number(item?.approval_amount || 0).toFixed(2),
                firm_name: <CustomToolTip>{item?.firm_id?.firm || "-"}</CustomToolTip>,
                service_date: item?.service_date
                    ? utils?.formateDateCalander(item?.service_date)
                    : "-",
                vendor_detail: (
                    <div onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/account/vendors/details/${item.vendor_detail?._id}?type=${constant.m_type.vendors}&tab=${1}&search=${item.vendor_detail?.name}&offset=${+1}&total_record=${25}&is_list=${true}`)
                    }}>
                        {item?.vendor_detail?.name || "-"}
                    </div>
                ),
                vehicle: <div>{item?.vehicle?.vehicle_no || "-"}</div>,
                sub_total: item?.total_amount ? `₹ ${item.total_amount.toFixed(2)}` : "₹ 0.00",
                due_amount: item?.due_amount ? `₹ ${item.due_amount.toFixed(2)}` : "₹ 0.00",
                // service_status: (
                //     <div style={{ fontSize: "14px", color: "#0FCA5A", fontWeight: 400 }}>
                //         {item?.payment_status}
                //     </div>
                // ),
                service_status: <span className="trs-status" style={{ background: color }}>{label}</span>,
                // actionButton: item?.payment_status !== "Completed" ? (
                //     <button
                //         className="dropbtn11"
                //         style={{
                //             border: "none", background: "#F3F6FF", color: "#0049D7",
                //             fontSize: "14px", padding: "5px 20px", width: "auto",
                //             borderRadius: "5px",
                //         }}
                //         onClick={(e) => { e.stopPropagation(); setIsOpenMakePayment(item); }}
                //     >
                //         Add Payment
                //     </button>
                // ) : null,

                 actionButton: (
                    <div className="_rSide_drp">
                        <div className="signDropdown">
                            <button className="dropbtn11">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                    <rect x="0.390625" y="0.390625" width="24.2188" height="24.2188" rx="2.73438" stroke="#0049D7" strokeWidth="0.78125" />
                                    <path d="M12.5 7.8125C13.3629 7.8125 14.0625 7.11295 14.0625 6.25C14.0625 5.38706 13.3629 4.6875 12.5 4.6875C11.6371 4.6875 10.9375 5.38706 10.9375 6.25C10.9375 7.11295 11.6371 7.8125 12.5 7.8125Z" fill="#0049D7" />
                                    <path d="M12.5 14.0625C13.3629 14.0625 14.0625 13.3629 14.0625 12.5C14.0625 11.6371 13.3629 10.9375 12.5 10.9375C11.6371 10.9375 10.9375 11.6371 10.9375 12.5C10.9375 13.3629 11.6371 14.0625 12.5 14.0625Z" fill="#0049D7" />
                                    <path d="M12.5 20.3125C13.3629 20.3125 14.0625 19.6129 14.0625 18.75C14.0625 17.8871 13.3629 17.1875 12.5 17.1875C11.6371 17.1875 10.9375 17.8871 10.9375 18.75C10.9375 19.6129 11.6371 20.3125 12.5 20.3125Z" fill="#0049D7" />
                                </svg>
                            </button>
                            <div className="dropdownContent"></div>
                        </div>
                    </div>
                ),
                serial: (
                    <div className="signDropdown">
                        <button className="dropbtn11"><BsThreeDotsVertical /></button>
                        <div className="dropdownContent">
                            <Link className="_avPointer" style={{ textDecoration: "none" }}>
                                <span className="_samAnchor">
                                    <span className="viewIcon_avt"><AiOutlineEye /></span>&nbsp; View
                                </span>
                            </Link>
                            <Link className="_avPointer" style={{ textDecoration: "none" }}>
                                <span className="_samAnchor">
                                    <span className="viewIcon_avt"><FiEdit /></span>&nbsp; Edit
                                </span>
                            </Link>
                            <div className="_avPointer">
                                <span className="_samAnchor">
                                    <span className="deleteIcon_avt"><FaRegTrashCan color="red" /></span> Delete
                                </span>
                            </div>
                        </div>
                    </div>
                ),
            }
        }

        );

    const onRowClick = (e, row) => {
        const originalItem = serviceList.find(item => item._id === row._id);
        console.log("Original item:", originalItem);
    };


    const handleRowClick = (item) => {
        navigate(
            `/accounting/ptransactions/${item._id}` +
            `?offset=${offset}&total_record=${totalRecord}&type=1` +
            `&sequence_no=${item.original?.sequence_no}` +
            `&status=${item.original?.payment_status}` +
            `&invoice=${item.original?.invoice}` +
            `&tab=${activeTab}`
        );
    };

    const paymentResult = (data, voucher_id) => {
        setIsProcessing(false);
        setIsOpenPayNow(false);
        setIsOpenMakePayment(false);
        setIsMakeStatusOpen(true);
        setPaymentData({ voucher_id, data });
    };

    const callbackEaesbuzz = (id, amount, venderDetails, payload) => {
        setEaesbuzzId(prev => ({
            ...prev,
            eb_account_id: id,
            total_amount: amount,
            vendor_bank_account: venderDetails?.vendor_bank_account,
            payload,
        }));
    };

    const doneHandle = () => {
        setIsOpenPayNow(false);
        setIsMakeStatusOpen(false);
        setIsOpenMakePayment(false);
    };

    const makePaymentProps = {
        isOpen: isOpenMakePayment,
        closeModal: () => setIsOpenMakePayment(false),
        headerPart: false, footerPart: true,
        modalMainClass: "_dashCommon_Modal _lgModal",
        modalTitle: "Make Payment",
        submitTitle: "Save",
        callBackFreight: getServiceHandle,
        setIsOpenPayNow,
        callbackEaesbuzz,
    };

    const payNowProps = {
        isOpen: isOpenPayNow,
        closeModal: () => setIsOpenPayNow(false),
        setIsProcessing,
        setIsOpenPayNow,
        easebuzzDetails: eaesbuzzId,
    };

    return (
        <>
            <div className="trs-exp-table">
                <BootstrapTable
                    tableClass="trs-exp-table-inner"
                    columns={columns}
                    data={rowListData(serviceList)}
                    onRowClick={(e, row) => handleRowClick(row)}
                />
                <div className="paginationFt_avt">
                    <CustomPagination
                        totalItems={totalRecord || 1}
                        itemsPerPage={ITEMS_PER_PAGE}
                        currentPage={offset}
                        onPageChange={onPageChange}
                    />
                </div>
            </div>

            {isOpenMakePayment && <MakePaymentOfServiceModal {...makePaymentProps} />}
            {isOpenPayNow && <PaymentConfirmModal {...payNowProps} />}
            {isProcessing && (
                <PaymentProcessingOffcanvas
                    isOpen={isProcessing}
                    message="Please wait while we process your transaction..."
                    paymentResult={paymentResult}
                    eaesbuzzId={eaesbuzzId}
                    onClose={() => { setIsProcessing(false); setIsOpenPayNow(false); setIsOpenMakePayment(false); }}
                />
            )}
            {isMakeStatusOpen && (
                <PaymentStatusCard
                    isOpen={isMakeStatusOpen}
                    onClose={() => setIsMakeStatusOpen(false)}
                    paymentData={paymentData}
                    details={{ _id: paymentData?.data?.voucher_id }}
                    onShareReceipt={() => { }}
                    viewReceiptHandle={(data) => { }}
                    doneHandle={doneHandle}
                />
            )}
        </>
    );
};

export default WorkshopServicingVoucher;